/* DC.SPORTS - extrait de layout/theme.liquid le 31/08/2026.
   Code identique a l'original, deplace ici pour etre mis en cache
   par le navigateur au lieu d'etre reecrit dans chaque page. */
(function(){
  "use strict";
  if (document.getElementById('dc-qa-guard')) return;              /* garde anti-doublon */
  var g = document.createElement('span');
  g.id = 'dc-qa-guard';
  g.style.display = 'none';
  (document.body || document.documentElement).appendChild(g);

  var CONTACT   = '/pages/contactez-nous';
  var GUIDE     = '/pages/quelle-raquette-choisir';
  var POINTURES = '/pages/guides-des-pointures-des-chaussures';
  var SEUIL     = 767;                                             /* px : au-dessous, version dans la page */

  /* Réponses écrites par le magasin. Aucune génération automatique : ce qui est
     affiché ici est ce que David a validé. Pour une question hors liste, on
     renvoie vers WhatsApp plutôt que d'inventer. */
  var COMMUNES = [
    { q: "Quels sont les délais ?",
      r: "Commande passée avant 14 h, elle part le jour même. Sinon le lendemain ouvré. Si vous avez choisi un cordage, comptez 24 h de plus : la raquette passe entre les mains de notre cordeur avant de partir." },
    { q: "Les frais de port ?",
      r: "La livraison en <b>point relais est offerte dès 50 €</b> d'achat. La livraison <b>à domicile est offerte dès 80 €</b>." }
  ];

  var AIDE = { q: "Besoin d'aide ?",
    r: "Cliquez sur l'onglet WhatsApp, en bas à droite de votre écran : David vous répondra rapidement." };

  var PIED = "Réponses écrites par le magasin, pas par une IA. Il manque quelque chose ? Cliquez sur l'onglet WhatsApp, David vous répondra rapidement.";

  var FAMILLES = {
    raquette: [
      { q: "Elle est livrée cordée ?", dyn: 'cordage' },
      { q: "Quelle tension choisir ?",
        r: "Vous débutez : autour de 10,5 kg. Le cordage travaille pour vous et le bras encaisse moins.<br>Vous jouez en club et cherchez du contrôle : 11 à 12,5 kg.<br>Vous frappez fort et jouez en compétition : 12,5 kg et plus.<br>Vous réglez la tension au kilo près juste au-dessus, au moment d'ajouter la raquette au panier." },
      { q: "Elle correspond à mon jeu ?",
        r: "Regardez le bloc <b>Profil de la raquette</b> plus haut : équilibre, flexibilité et poids y sont notés. En tête + rigide, c'est fait pour attaquer. En manche + souple, c'est la vitesse de main et la défense. Neutre, c'est polyvalent. Si vous hésitez entre deux modèles, le <a href=\"" + GUIDE + "\">guide de choix</a> compare les profils." }
    ],
    chaussure: [
      { q: "Je prends quelle pointure ?",
        r: "Consultez notre <a href=\"" + POINTURES + "\">guide des pointures</a> : les correspondances y sont données marque par marque. Un doute sur ce modèle précis ? Cliquez sur l'onglet WhatsApp, David vous répondra rapidement." },
      { q: "La semelle est non marquante ?",
        r: "Oui. Les chaussures indoor de badminton sont conçues avec une semelle gomme non marquante, exigée dans la quasi-totalité des gymnases." },
      { q: "Ça marche pour le squash ?",
        r: "En salle, oui : le squash demande le même type d'appui et la même semelle indoor. Le padel, en revanche, se joue sur gazon synthétique et réclame une semelle à chevrons — ce n'est pas le même produit." }
    ],
    sac: [
      { q: "Combien de raquettes ?",
        r: "La capacité annoncée par la marque figure dans la description ci-dessous (2, 3, 6, 9 ou 12 raquettes). C'est une capacité théorique, housses comprises : comptez un peu moins si vous transportez aussi des chaussures et des affaires." },
      { q: "Il y a un compartiment chaussures ?",
        r: "Sur les modèles à partir de 6 raquettes et sur les thermobags, le plus souvent oui. La description ci-dessous le précise pour ce modèle." },
      { q: "C'est quoi un thermobag ?",
        r: "Un sac doublé d'une couche isolante qui protège les cordages des écarts de température. Utile si le sac passe la nuit dans une voiture en hiver, ou l'après-midi dans un coffre en été : un cordage encaisse mal les deux." }
    ],
    cordage: [
      { q: "La pose est comprise ?",
        r: "Pas sur le cordage vendu seul. En revanche, si vous achetez une raquette, vous choisissez votre cordage et votre tension sur sa fiche et <b>la pose est comprise dans le prix affiché</b>. Vous pouvez aussi nous apporter votre raquette au magasin." },
      { q: "Quelle tension choisir ?",
        r: "Vous débutez : autour de 10,5 kg. Vous jouez en club : 11 à 12,5 kg. Vous frappez fort : 12,5 kg et plus. Plus la tension monte, plus le cordage casse vite — c'est le prix du contrôle." },
      { q: "Il va durer longtemps ?",
        r: "Cela dépend surtout de votre frappe et de la tension. Un cordage fin (0,61 à 0,66 mm) donne du toucher et de la puissance mais s'use plus vite ; un 0,70 mm dure plus longtemps et pardonne davantage. Pour un premier cordage, on conseille le 0,70." }
    ],
    volant: [
      { q: "Plumes ou nylon ?",
        r: "Plumes pour le jeu en club et en compétition : la trajectoire et le toucher n'ont pas d'équivalent, mais la durée de vie est courte. Nylon pour l'entraînement, le loisir et les jeunes : ça dure bien plus longtemps pour un coût au match très inférieur." },
      { q: "Quelle vitesse prendre ?",
        r: "La vitesse est donnée par un numéro (de 75 à 79) : plus le numéro est bas, plus le volant est lent. Une salle chaude fait voler les volants plus loin, on descend d'un cran ; une salle froide, on monte d'un cran. Si votre club a une habitude, suivez-la." },
      { q: "Combien dans un tube ?",
        r: "Un tube standard contient 12 volants. La quantité exacte de ce modèle est précisée dans la description ci-dessous." }
    ],
    grip: [
      { q: "Grip ou surgrip ?",
        r: "Le grip est le revêtement d'origine, collé sur le manche. Le surgrip s'enroule par-dessus : c'est lui qu'on change régulièrement, il protège le grip et ajuste l'épaisseur du manche à votre main." },
      { q: "Je le change quand ?",
        r: "Dès qu'il devient glissant ou que la mousse est écrasée. Pour un joueur qui s'entraîne deux fois par semaine, comptez un surgrip par mois environ." }
    ]
  };

  function h1(){ var e = document.querySelector('h1'); return e ? (e.textContent || '') : ''; }

  /* La réponse « livrée cordée ? » dépend du produit : le titre le dit. */
  function reponseCordage(){
    var t = h1().toLowerCase();
    if (t.indexOf('non cord') !== -1){
      return "Cette raquette est vendue <b>non cordée</b>. Juste au-dessus, choisissez votre cordage et votre tension : nous la cordons ici, à Morsang-sur-Orge, par un cordeur certifié Yonex, et la pose est comprise dans le prix affiché. Comptez 24 h de plus avant l'expédition.";
    }
    if (t.indexOf('cord') !== -1){
      return "Oui, cette raquette est livrée <b>déjà cordée</b>. Si vous préférez un autre cordage ou une autre tension, dites-le nous en commentaire de commande ou <a href=\"" + CONTACT + "\">écrivez-nous</a> : on s'en occupe avant l'envoi.";
    }
    return "Le titre du produit précise si elle est cordée ou non. Si elle est vendue non cordée, vous choisissez votre cordage et votre tension juste au-dessus, et la pose est comprise dans le prix affiché.";
  }

  function famille(){
    var type = '';
    try { type = (window.ShopifyAnalytics.meta.product.type || '').toLowerCase(); } catch(e){}
    if (!type) return null;
    if (type.indexOf('tennis') !== -1) return null;                 /* hors périmètre badminton */
    if (type.indexOf('raquette') !== -1) return 'raquette';
    if (type.indexOf('chaussure') !== -1 || type.indexOf('claquette') !== -1) return 'chaussure';
    if (type.indexOf('sac') !== -1) return 'sac';
    if (type.indexOf('cordage') !== -1 || type.indexOf('bobine') !== -1) return 'cordage';
    if (type.indexOf('volant') !== -1) return 'volant';
    if (type.indexOf('grip') !== -1 || type.indexOf('garniture') !== -1) return 'grip';
    return null;
  }

  function questions(){
    var f = famille();
    if (!f) return null;
    return (FAMILLES[f] || []).slice().concat(COMMUNES).concat([AIDE]);
  }

  function texte(item){ return item.dyn === 'cordage' ? reponseCordage() : item.r; }

  function petitEcran(){
    return (window.innerWidth || document.documentElement.clientWidth || 0) <= SEUIL;
  }

  /* Où poser le bloc mobile : juste après le formulaire d'ajout au panier,
     donc sous le bouton, là où la question se pose vraiment. */
  function ancreInline(){
    var f = document.querySelector('form[action*="/cart/add"]');
    if (f && f.parentNode) return { noeud: f, mode: 'apres' };
    var d = document.querySelector('.product-single__description, .product__description, [class*="product"][class*="description"]');
    if (d && d.parentNode) return { noeud: d, mode: 'avant' };
    return null;
  }

  /* ---------- rendu ordinateur ---------- */
  function construireFlottant(liste){
    var box = document.createElement('div');
    box.id = 'dc-qa';

    var panneau = document.createElement('div');
    panneau.id = 'dc-qa-panneau';
    panneau.innerHTML =
      '<div class="dc-qa-tete"><span class="dc-qa-titre">LES QUESTIONS QU\'ON NOUS POSE</span>' +
      '<button type="button" class="dc-qa-fermer" aria-label="Fermer">&times;</button></div>' +
      '<div class="dc-qa-corps"><p class="dc-qa-q"></p><p class="dc-qa-r"></p></div>' +
      '<div class="dc-qa-autres"></div>' +
      '<div class="dc-qa-pied">' + PIED + '</div>';

    var chips = document.createElement('div');
    chips.style.cssText = 'display:flex;flex-direction:column;align-items:flex-end;gap:8px';

    function ouvrir(i){
      var item = liste[i];
      panneau.querySelector('.dc-qa-q').textContent = item.q;
      panneau.querySelector('.dc-qa-r').innerHTML = texte(item);
      var autres = panneau.querySelector('.dc-qa-autres');
      autres.innerHTML = '';
      liste.forEach(function(o, j){
        if (j === i) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = o.q;
        b.addEventListener('click', function(){ ouvrir(j); });
        autres.appendChild(b);
      });
      panneau.classList.add('dc-ouvert');
      chips.style.display = 'none';
      panneau.querySelector('.dc-qa-corps').scrollTop = 0;
    }

    function fermer(){
      panneau.classList.remove('dc-ouvert');
      chips.style.display = 'flex';
    }

    liste.forEach(function(item, i){
      if (i > 2 && item !== AIDE) return;                           /* 3 questions + le bouton d'aide */
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'dc-qa-chip' + (item === AIDE ? ' dc-qa-aide' : '');
      c.textContent = item.q;
      c.addEventListener('click', function(){ ouvrir(i); });
      chips.appendChild(c);
    });

    panneau.querySelector('.dc-qa-fermer').addEventListener('click', fermer);
    box.appendChild(panneau);
    box.appendChild(chips);
    document.body.appendChild(box);
    return box;
  }

  /* ---------- rendu mobile ---------- */
  function construireInline(liste, ancre){
    var box = document.createElement('div');
    box.id = 'dc-qa-inline';

    var html = '<div class="dc-qi-tete">LES QUESTIONS QU\'ON NOUS POSE</div>';
    box.innerHTML = html;

    liste.forEach(function(item){
      var bloc = document.createElement('div');
      bloc.className = 'dc-qi-item';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dc-qi-q';
      b.textContent = item.q;
      var p = document.createElement('div');
      p.className = 'dc-qi-r';
      p.innerHTML = texte(item);
      b.addEventListener('click', function(){
        var deja = bloc.classList.contains('dc-ouvert');
        box.querySelectorAll('.dc-qi-item').forEach(function(x){ x.classList.remove('dc-ouvert'); });
        if (!deja) bloc.classList.add('dc-ouvert');
      });
      bloc.appendChild(b);
      bloc.appendChild(p);
      box.appendChild(bloc);
    });

    var pied = document.createElement('div');
    pied.className = 'dc-qi-pied';
    pied.textContent = PIED;
    box.appendChild(pied);

    if (ancre.mode === 'apres') ancre.noeud.parentNode.insertBefore(box, ancre.noeud.nextSibling);
    else ancre.noeud.parentNode.insertBefore(box, ancre.noeud);
    return box;
  }

  var courant = null;      /* élément posé */
  var modeCourant = null;  /* 'mobile' | 'bureau' */

  function retirer(){
    if (courant && courant.parentNode) courant.parentNode.removeChild(courant);
    courant = null;
    modeCourant = null;
  }

  function poser(){
    var liste = questions();
    if (!liste) return false;
    if (!document.querySelector('h1')) return false;                /* page pas encore rendue */

    if (petitEcran()){
      var ancre = ancreInline();
      if (!ancre) return false;                                     /* on attend le formulaire */
      courant = construireInline(liste, ancre);
      modeCourant = 'mobile';
    } else {
      courant = construireFlottant(liste);
      modeCourant = 'bureau';
    }
    return true;
  }

  /* Rotation de l'écran ou redimensionnement : on rebascule d'un rendu à l'autre. */
  var minuteurTaille = null;
  window.addEventListener('resize', function(){
    clearTimeout(minuteurTaille);
    minuteurTaille = setTimeout(function(){
      if (!modeCourant) return;
      var voulu = petitEcran() ? 'mobile' : 'bureau';
      if (voulu === modeCourant) return;
      retirer();
      poser();
    }, 250);
  });

  if (poser()) return;

  /* ShopifyAnalytics, le titre et le formulaire arrivent parfois après le
     script : on attend, sans s'éterniser. */
  var obs = new MutationObserver(function(){ if (poser()) stop(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  var minuteur = setTimeout(stop, 15000);

  function stop(){
    clearTimeout(minuteur);
    try { obs.disconnect(); } catch(e){}
  }
})();
